import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  template: `
    <div [ngStyle]="getStyles()" class="skeleton-load loader"></div>
  `,
  styleUrls: ['./skeleton-load.component.scss'],
})
export class SkeletonLoadComponent implements OnInit {
  @Input()
  contentWidth;

  @Input()
  contentHeight;

  @Input()
  circle: boolean;

  constructor() {}

  ngOnInit() {}

  getStyles() {
    const styles: any = {
      'width.px': this.contentWidth ? this.contentWidth : '',
      'height.px': this.contentHeight ? this.contentHeight : '',
      borderRadius: this.circle ? '50%' : '',
    };
    if (this.contentWidth === '100%') {
      styles.width = '100%';
    }
    return styles;
  }
}
